import { useState, useEffect } from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Card";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Form } from "react-bootstrap";
import sb_pin from "Assets/Icons/push-pin.svg";
import "Pages/SbSbGroupSkillsProficiencyHR/SbSbGroupSkillsProficiencyHR.scss";
import SbWarningToaster from "Components/SbErrorToasterComponent/SbWarningToaster.jsx";
import SbInfoToaster from "Components/SbErrorToasterComponent/SbInfoToaster.jsx";
import SbWarningAlert from "Components/SbAlertComponent/SbWarningAlert.jsx";
import { getSBEmployeeScaleDefinition } from "Api/apiService";

const SbSbGroupSkillsProficiencyHR = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("skills-bridger");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isChecked, setIsChecked] = useState(false);
  const [pendingUpdate, setPendingUpdate] = useState(null); // {index, delta}
  const [showWarning, setShowWarning] = useState(false);
  const [viewToaster, setViewToaster] = useState(false);
  const [showConditionalAlert, setShowConditionalAlert] = useState(false);
  const [scaleData, setScaleData] = useState(null);
  const [showSkillsDropdown, setShowSkillsDropdown] = useState(false);

  const [skills, setSkills] = useState([
    {
      skill_id: 1,
      skill_title: "Collaboration",
      skill_description: "Ability to work well in a team environment",
      current_proficiency: 3,
      required_proficiency: 4,
      priority_skill: false,
    },
    {
      skill_id: 2,
      skill_title: "Problem Solving",
      skill_description: "Identifying and resolving issues effectively",
      current_proficiency: 2,
      required_proficiency: 5,
      priority_skill: true,
    },
    {
      skill_id: 3,
      skill_title: "Problem Solving",
      skill_description: "Identifying and resolving issues effectively",
      current_proficiency: 3,
      required_proficiency: 5,
      priority_skill: true,
    },
    {
      skill_id: 4,
      skill_title: "Problem Solving",
      skill_description: "Identifying and resolving issues effectively",
      current_proficiency: 1,
      required_proficiency: 5,
      priority_skill: true,
    },
    {
      skill_id: 5,
      skill_title: "Problem Solving",
      skill_description: "Identifying and resolving issues effectively",
      current_proficiency: 5,
      required_proficiency: 3,
      priority_skill: true,
    },
    {
      skill_id: 6,
      skill_title: "Problem Solving",
      skill_description: "Identifying and resolving issues effectively",
      current_proficiency: 4,
      required_proficiency: 3,
      priority_skill: true,
    },
    // Add more skills as needed
  ]);

  const formattedScale = scaleData?.proficiency_scale
    .map((item, index) => {
      return `<span>${index}: ${item.name}</span> - ${item.description} <br /><br />`;
    })
    .join("");

  const sb_ep_fetchScaleDefinition = async () => {
    setLoading(true);
    setError(null);

    try {
      const scaleDefinitionResponse = await getSBEmployeeScaleDefinition();
      if (scaleDefinitionResponse) {
        console.log("scaleDefinitionResponse is present");
        console.log(scaleDefinitionResponse);
        setScaleData(scaleDefinitionResponse);
      } else {
        setError("No scale definition found.");
      }
    } catch (err) {
      console.error("Error fetching scale definition:", err);
      setError("Failed to fetch scale definition. Please try again.");
    } finally {
      setLoading(false); // Set loading to false once fetch is done
    }
  };
  useEffect(() => {
    sb_ep_fetchScaleDefinition();
  }, []);

  const handleOnBackClick = () => {
    navigate(`/Skills-bridger`);
  };

  // function to handle the tab selection in jobs library page.
  const handleTabClick = (tabKey) => {
    setActiveTab(tabKey);
  };

  const handleProficiencyChange = (index, delta) => {
    setPendingUpdate({ index, delta });
    setShowWarning(true);
  };

  const handleWarningOk = () => {
    if (pendingUpdate) {
      updateProficiency(pendingUpdate.index, pendingUpdate.delta);
    }
    setShowWarning(false);
    setPendingUpdate(null);
  };

  const handleWarningCancel = () => {
    setShowWarning(false);
    setPendingUpdate(null);
  };

  const updateProficiency = (index, delta) => {
    setSkills((prevSkills) =>
      prevSkills.map((skill, i) =>
        i === index
          ? {
              ...skill,
              required_proficiency: Math.min(
                5,
                Math.max(0, skill.required_proficiency + delta)
              ),
            }
          : skill
      )
    );
  };

  const togglePriority = (index) => {
    setSkills((prevSkills) =>
      prevSkills.map((skill, i) =>
        i === index
          ? { ...skill, priority_skill: !skill.priority_skill }
          : skill
      )
    );
  };

  return (
    <div>
      <Card className="border-0 rounded-0 shadow-sm">
        <Card.Body>
          <div className="d-flex align-items-center">
            <Button
              variant="link"
              onClick={handleOnBackClick}
              className="me-3 btn border-0"
            >
              {/* Back icon */}
              <svg
                width="24"
                height="22"
                viewBox="0 0 24 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_1478_14276)">
                  <path
                    d="M29.334 11L4.88954 11"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M11 4.58203L4.58333 10.9987L11 17.4154"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1478_14276">
                    <rect
                      width="24"
                      height="22"
                      fill="white"
                      transform="matrix(-1 0 0 1 24 0)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </Button>
            <Card.Title className="text-start jobs-heading">
              Group -
              <small className="text-body-tertiary jobs-description ms-3">
                Multiple businesses, multiple locations, multiple functions,
                multiple job-grades, multiple roles, multiple employees.
              </small>
            </Card.Title>
          </div>

          {/* Custom Tabs with divs */}
          <div className="custom-tabs">
            <div className="tab-titles">
              <div
                className={`tab-title ${activeTab === "jd" ? "active" : ""}`}
                onClick={() => handleTabClick("jd")}
              >
                Jobs Library
              </div>

              <div className="d-flex position-relative">
                <div
                  className={`tab-title ${activeTab === "skills-bridger" ? "active" : ""} skills-bridger-tab`}
                  onClick={() => {
                    setActiveTab("skills-bridger");
                    setShowSkillsDropdown((prev) => !prev);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  Skills Bridger
                  <svg
                    className={showSkillsDropdown ? "dropdown-arrow open" : "dropdown-arrow"}
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M12 6.5C12 6.22 11.78 6 11.5 6H4.5C4.22 6 4 6.22 4 6.5C4 6.63 4.05 6.74 4.13 6.83L7.63 10.83C7.72 10.93 7.85 11 8 11C8.15 11 8.28 10.93 8.37 10.83L11.87 6.83C11.95 6.74 12 6.63 12 6.5Z"
                      fill="#8F95B2"
                    />
                  </svg>
                </div>
                {activeTab === "skills-bridger" && showSkillsDropdown && (
                  <div className="skills-bridger-dropdown">
                    <div
                      className="dropdown-item"
                      onClick={() => {
                        setShowSkillsDropdown(false);
                        // already on this page, so do nothing or reload if needed
                      }}
                    >
                      Skills Proficiency
                    </div>
                    <div
                      className="dropdown-item"
                      onClick={() => {
                        setShowSkillsDropdown(false);
                        navigate("/skills-bridger/skills-map");
                      }}
                    >
                      Skills Map
                    </div>
                  </div>
                )}
              </div>

              <div
                className={`tab-title ${
                  activeTab === "learning-catalyst" ? "active" : ""
                } `}
                onClick={() => handleTabClick("learning-catalyst")}
                style={{ cursor: "pointer" }}
              >
                Learning Catalyst
              </div>

              <div
                className={`tab-title ${
                  activeTab === "talent-mobility" ? "active" : ""
                } `}
                onClick={() => handleTabClick("talent-mobility")}
                style={{ cursor: "pointer" }}
              >
                Talent Mobility
              </div>
            </div>
          </div>
        </Card.Body>

        {activeTab === "skills-bridger" && (
          <table className="table table-hover">
            <thead className="align-middle">
              <tr className="text-body-tertiary text-start text-uppercase jobs-table-heading">
                <th className="bg-tertiary ps-3">Skill name</th>
                <th className="bg-tertiary">
                  <div className="d-flex flex-column">
                    <div>
                      Inferred Proficiency{" "}
                      <span className="text-muted">(0-5 Scale)</span>
                    </div>

                    <div>
                      <svg
                        width="8"
                        height="8"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          width="8"
                          height="8"
                          rx="2"
                          ry="2"
                          fill="#007bff"
                        />
                      </svg>
                      <span className="text-muted p-2 small text-capitalize">
                        Current Proficiency
                      </span>
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 16 16"
                        fill="#474D66"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ transform: "rotate(180deg)" }}
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M13 4.00977C13 3.45977 12.55 3.00977 12 3.00977H4C3.45 3.00977 3 3.45977 3 4.00977C3 4.16977 3.05 4.31977 3.11 4.44977H3.1L7.1 12.4498H7.11C7.27 12.7798 7.6 13.0098 8 13.0098C8.4 13.0098 8.72 12.7798 8.89 12.4498H8.9L12.9 4.44977H12.89C12.95 4.30977 13 4.16977 13 4.00977Z"
                          fill="#008080"
                        />
                      </svg>
                      <span className="text-muted p-2 small text-capitalize">
                        Required Proficiency{" "}
                        <span className="text-muted text-lowercase">
                          (change using + and - buttons)
                        </span>
                      </span>
                    </div>
                  </div>
                </th>
                <th className="bg-tertiary text-center">
                  Priority Skills To Develop
                </th>
              </tr>
            </thead>

            <tbody>
              {skills.map((skill, index) => (
                <tr key={skill.skill_id}>
                  <td className="task-name text-start p-3 col-3 align-middle">
                    <div>
                      <div className="task-item">
                        <span className="task-text">{skill.skill_title}</span>
                      </div>
                      <div className="text-body-tertiary task-desc">
                        {skill.skill_description}
                      </div>
                    </div>
                  </td>

                  <td className="py-4 col-4">
                    <div className="d-flex align-items-center gap-3">
                      {/* Decrement Button */}
                      <button
                        className="changeProficiencyButton"
                        onClick={
                          //() => handleProficiencyChange(index, -1)
                          () => setShowConditionalAlert(true)
                        }
                        disabled={true || skill.required_proficiency <= 0}
                      >
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            width="24"
                            height="24"
                            rx="4"
                            fill="#E5E7EB"
                            stroke="none"
                          />
                          <g transform="translate(6, 6) scale(0.80)">
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M13 7H3C2.45 7 2 7.45 2 8C2 8.55 2.45 9 3 9H13C13.55 9 14 8.55 14 8C14 7.45 13.55 7 13 7Z"
                              fill="#2B3034"
                            />
                          </g>
                        </svg>
                      </button>
                      <div
                        className="progress-bar-visual-wrapper mt-3"
                        style={{ position: "relative", width: "100%" }}
                      >
                        {/* Triangle pointer */}
                        <div
                          className="triangle-pointer"
                          style={{
                            left: `calc(${
                              (skill.required_proficiency / 5) * 100
                            }% - 1px)`,
                            top: `23px`,
                          }}
                        >
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 16 16"
                            fill="#474D66"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M13 4.00977C13 3.45977 12.55 3.00977 12 3.00977H4C3.45 3.00977 3 3.45977 3 4.00977C3 4.16977 3.05 4.31977 3.11 4.44977H3.1L7.1 12.4498H7.11C7.27 12.7798 7.6 13.0098 8 13.0098C8.4 13.0098 8.72 12.7798 8.89 12.4498H8.9L12.9 4.44977H12.89C12.95 4.30977 13 4.16977 13 4.00977Z"
                              fill="#008080"
                              stroke="white"
                              strokeWidth="1"
                            />
                          </svg>
                          <div style={{ transform: "rotate(180deg)" }}>
                            {skill.required_proficiency}
                          </div>
                        </div>
                        <div className="progress-bar-container flex-grow-1">
                          <div
                            className="progress-bar-current"
                            style={{
                              width: `${
                                (skill.current_proficiency / 5) * 100
                              }%`,
                            }}
                          >
                            <span className="progress-label">
                              {skill.current_proficiency}
                            </span>
                          </div>
                        </div>
                      </div>
                      {/* Increment Button */}
                      <button
                        className="changeProficiencyButton"
                        onClick={
                          //() => handleProficiencyChange(index, +1)
                          () => setShowConditionalAlert(true)
                        }
                        disabled={skill.required_proficiency >= 5}
                      >
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            width="24"
                            height="24"
                            rx="4"
                            fill="#E5E7EB"
                            stroke="none"
                          />
                          <g transform="translate(2, 2) scale(1.20)">
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M9 7V3.5C9 3.22 8.78 3 8.5 3C8.22 3 8 3.22 8 3.5V7H4.5C4.22 7 4 7.22 4 7.5C4 7.78 4.22 8 4.5 8H8V11.5C8 11.78 8.22 12 8.5 12C8.78 12 9 11.78 9 11.5V8H12.5C12.78 8 13 7.78 13 7.5C13 7.22 12.78 7 12.5 7H9Z"
                              fill="#2B3034"
                            />
                          </g>
                        </svg>
                      </button>
                    </div>
                  </td>

                  <td className="task-name p-4 col-2 align-middle">
                    <div className="d-flex align-items-center justify-content-center gap-4">
                      <div className="jobs-table-critical-checkbox">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          checked={skill.priority_skill}
                          onChange={() => togglePriority(index)}
                        />
                      </div>
                      <div
                        className="badge badge-primary rounded-pill"
                        style={{
                          visibility: skill.priority_skill
                            ? "visible"
                            : "hidden",
                        }}
                      >
                        <img className="me-2" src={sb_pin} width={26} />
                      </div>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        {activeTab === "skills-bridger" && (
          <Container fluid className="px-4 py-2 sticky-bottom bg-white border">
            <Row className="text-start mt-2 mb-2 border-bottom">
              <h6 className="small pb-2">SKILLS PROFICIENCY SCALE</h6>
              <div className="d-flex flex-row gap-4 pb-2">
                {scaleData?.proficiency_scale &&
                  scaleData.proficiency_scale.map((field, index) => (
                    <div className="px-4 pb-2 pt-2" key={index}>
                      {field.level} : <span>{field.name}</span>
                    </div>
                  ))}
                <Button
                  variant="outline-secondary"
                  className="px-4 pb-2 pt-2 align-self-end"
                  onClick={() => setViewToaster(true)}
                >
                  <h6 className="small">View details</h6>
                </Button>
              </div>
            </Row>
            <Row className="align-items-center justify-content-between mb-3">
              {/* Left side: Items per page */}
              <Col xs="auto">
                <Row className="align-items-center g-2">
                  <Col xs="auto">Showing</Col>
                  <Col xs="auto">
                    <Form.Select
                      aria-label="Default select example"
                      size="sm"
                      className="bg-light"
                    >
                      <option value="10">10</option>
                      <option value="20">20</option>
                      <option value="30">30</option>
                    </Form.Select>
                  </Col>
                  <Col xs="auto">Items per page</Col>
                </Row>
              </Col>

              {/* Right side: Pagination */}
              <Col xs="auto">
                <Row className="align-items-center g-2">
                  <Col xs="auto">Page</Col>
                  <Col xs="auto">
                    <Form.Control
                      size="sm"
                      type="tel"
                      style={{ width: 30 }}
                      className="bg-light"
                    />
                  </Col>
                  <Col xs="auto">of</Col>
                  <Col xs="auto">
                    <ButtonGroup>
                      <Button variant="secondary">
                        {/* Left Arrow SVG */}
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <g opacity="0.6">
                            <path
                              d="M15.41 16.4064L10.83 12L15.41 7.59359L14 6.23999L8 12L14 17.76L15.41 16.4064Z"
                              fill="#8790A4"
                            />
                          </g>
                        </svg>
                      </Button>
                      <Button variant="secondary">
                        {/* Right Arrow SVG */}
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <g opacity="0.9">
                            <path
                              d="M8.59 16.4064L13.17 12L8.59 7.59359L10 6.23999L16 12L10 17.76L8.59 16.4064Z"
                              fill="#565E70"
                            />
                          </g>
                        </svg>
                      </Button>
                    </ButtonGroup>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        )}
      </Card>
      {showWarning && (
        <SbWarningToaster
          message=""
          show={showWarning}
          onClose={handleWarningCancel}
          action="Change"
          actionFunction={handleWarningOk}
          title="Change required skills proficiency?"
          disabled={false}
        />
      )}
      {viewToaster && (
        <div style={{ zIndex: 3000 }}>
          <SbInfoToaster
            message={"Message"}
            onClose={() => setViewToaster(false)}
            action="Hide Details"
            actionFunction={() => setViewToaster(false)}
            show={viewToaster}
            title="Skills Proficiency Scale"
            viewCancel={false}
          />
        </div>
      )}
      {showConditionalAlert && (
        <SbWarningAlert
          message="You can only change a group if all employees share the same role, function, business unit, and location."
          show={showConditionalAlert}
          title=""
          setShow={setShowConditionalAlert}
        />
      )}
      {scaleData?.proficiency_scale && viewToaster && (
        <div style={{ zIndex: 3000 }}>
          <SbInfoToaster
            message={formattedScale}
            onClose={() => setViewToaster(false)}
            action="Hide Details"
            actionFunction={() => setViewToaster(false)}
            show={viewToaster}
            title="Skills Proficiency Scale"
            viewCancel={false}
          />
        </div>
      )}
    </div>
  );
};

export default SbSbGroupSkillsProficiencyHR;
